import {
  FaCity,
  FaEnvelope,
  FaHome,
  FaMapMarkerAlt,
  FaMapPin,
  FaPhoneAlt,
  FaRegBuilding,
  FaRegMap,
  FaRegUser,
  FaUser
} from 'react-icons/fa';
import {
  VegasCard,
  SectionHeader,
  SectionDivider,
  IconInput,
  IconSelect,
  US_STATE_OPTIONS
} from 'components/VegasConference';

const PersonalInfo = ({ primaryPerson, company, address, city, state, zip, setForm, form, showError }) => {
  const personalInfoFields = [
    { key: 'name', label: 'Full Name', value: primaryPerson.name, icon: FaRegUser },
    { key: 'company', label: 'Franchise', value: company, icon: FaRegBuilding },
    { key: 'phone', label: 'Phone', value: primaryPerson.phone, icon: FaPhoneAlt, type: 'tel' },
    { key: 'email', label: 'Email', value: primaryPerson.email, icon: FaEnvelope, type: 'email' }
  ];

  const billingAddressFields = [
    { key: 'address', label: 'Address', value: address, icon: FaHome },
    { key: 'city', label: 'City', value: city, icon: FaCity },
    { key: 'state', label: 'State', value: state, icon: FaRegMap, options: US_STATE_OPTIONS },
    { key: 'zip', label: 'Zip Code', value: zip, icon: FaMapPin }
  ];

  return (
    <VegasCard>
      <SectionHeader
        icon={FaUser}
        title="Personal Information"
        subtitle="Tell us a little about yourself."
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {personalInfoFields.map((f) => (
          <IconInput
            key={f.key}
            icon={f.icon}
            label={f.label}
            type={f.type}
            required
            value={f.value}
            hasError={showError && !f.value}
            onChange={(value) => {
              if (f.key === 'company') {
                setForm({ ...form, company: value });
              } else {
                setForm({ ...form, primaryPerson: { ...form.primaryPerson, [f.key]: value } });
              }
            }}
          />
        ))}
      </div>

      <SectionDivider />

      <SectionHeader
        icon={FaMapMarkerAlt}
        title="Billing Details"
        subtitle="Enter your billing address."
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {billingAddressFields.map((f) => {
          const props = {
            icon: f.icon,
            label: f.label,
            required: true,
            value: f.value,
            hasError: showError && !f.value,
            onChange: (value) => setForm({ ...form, [f.key]: value })
          };

          return f.options ? (
            <IconSelect key={f.key} {...props} options={f.options} />
          ) : (
            <IconInput key={f.key} {...props} />
          );
        })}
      </div>
    </VegasCard>
  );
};

export default PersonalInfo;
